import { buildProps } from "@xplus/utils/props";
import { useSizeProp } from "@xplus/hooks";
import type { ExtractPropTypes } from "vue";

export const xInputProps = buildProps({
  size: useSizeProp,
} as const);

export type XInputProps = ExtractPropTypes<typeof xInputProps>;
